module.exports = __webpack_public_path__ + "img/icon_default_woman.cc35827d.png";